/**
 * The phase enum, in its own module so that anything keyed on it can import it
 * without importing the ephemeris.
 *
 * Split out when `phaseName.ts` moved into core: it needs the enum, and
 * `Moon/index.ts` re-exports `phaseName`, so importing the enum from the barrel
 * created a cycle. Under jest's CommonJS interop the cycle resolved and 4221
 * core tests passed; under vitest's ESM it left `EMoonPhase` undefined at
 * module-init and took out the entire webapp suite. Import from here, never from
 * `./index`.
 *
 * `COUNT` is a length marker rather than a phase, which is why lookups keyed on
 * this enum have to exclude it.
 */
export enum EMoonPhase {
  New = 0,
  WaxingCrescent,
  QuarterMoon,
  WaxingGibbous,
  Full,
  WaningGibbous,
  LastQuarter,
  WaningCrescent,
  COUNT = 8,
}
